import { render } from 'react-dom';
import React from 'react';

import { ProviderWithGlobalStore } from 'tradera-state/configure-store';
import { warnIfDevBuild } from 'utils/environment';
import { logger } from 'packages';
import QuickView from './quick-view-modal';
import './quick-view-modal.scss';

warnIfDevBuild('quick-view');

const mountQuickView = El => {
    if (El) {
        try {
            render(
                <ProviderWithGlobalStore>
                    <QuickView />
                </ProviderWithGlobalStore>,
                El
            );
        } catch (e) {
            logger(e);
        }
    }
};
export default () => {
    const El = Array.from(document.querySelectorAll('#quick-view'));
    if (El) {
        mountQuickView(El[0]);
    }
};
